import { useEffect } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { api } from '../../../lib/apiClient';
import { STALE_TIME } from './config';

export const useGetWorkspaces = () => {
  const workspacesPaginatedQuery = useInfiniteQuery({
    queryKey: ['workspaces-paginated'],
    queryFn: ({ pageParam = 1 }) => {
      const endpoint = endpoints.workspaces.list({
        pageSize: 100,
        page: pageParam,
      });

      // We need full workspaces in order to construct queue select
      return api.request(endpoint);
    },

    getNextPageParam: (lastPage, pages) =>
      pages.length < lastPage.pagination.totalPages
        ? pages.length + 1
        : undefined,
    staleTime: STALE_TIME,
  });

  const { isFetching, hasNextPage, fetchNextPage, isError } =
    workspacesPaginatedQuery;

  useEffect(() => {
    if (!isFetching && hasNextPage && !isError) {
      fetchNextPage();
    }
  }, [isFetching, hasNextPage, fetchNextPage, isError]);

  return workspacesPaginatedQuery;
};
